import { registerModule } from '../../core/module.js';
import { Sales, Customers, Credits, Expenses } from './Money.js';
import { Owed } from './Owed.js';
import { Bills, BillDetail, SupplierAccount } from './Bills.js';

/** Sales history, customers, store credit and expenses. */
export default registerModule({
  id: 'money',
  order: 50,
  nav: [
    { to: '/sales', labelKey: 'nav.sales', icon: '📜', group: 'money', permission: 'sales.history', order: 2, hintKey: 'nav.hintSales' },
    { to: '/customers', labelKey: 'nav.customers', icon: '👥', group: 'money', permission: 'customer.view', order: 4, hintKey: 'nav.hintCustomers' },
    { to: '/owed', labelKey: 'nav.owed', icon: '🤝', group: 'money', permission: 'customer.view', order: 4.5, hintKey: 'nav.hintOwed', requiresSetting: 'customerTabsEnabled' },
    { to: '/bills', labelKey: 'nav.bills', icon: '🧾', group: 'money', permission: 'purchase.view', order: 4.7, hintKey: 'nav.hintBills' },
    { to: '/credits', labelKey: 'nav.credits', icon: '🎟', group: 'money', permission: 'credit.view', order: 5, hintKey: 'nav.hintCredits' },
    { to: '/expenses', labelKey: 'nav.expenses', icon: '🧮', group: 'money', permission: 'expense.view', order: 6, hintKey: 'nav.hintExpenses' },
  ],
  routes: [
    { path: '/sales', element: <Sales />, permission: 'sales.history', titleKey: 'sales.title' },
    { path: '/customers', element: <Customers />, permission: 'customer.view', titleKey: 'customers.title' },
    { path: '/owed', element: <Owed />, permission: 'customer.view', titleKey: 'tab.title', requiresSetting: 'customerTabsEnabled' },
    { path: '/bills', element: <Bills />, permission: 'purchase.view', titleKey: 'bills.title' },
    { path: '/bills/:id', element: <BillDetail />, permission: 'purchase.view', titleKey: 'bills.title' },
    { path: '/suppliers/:id', element: <SupplierAccount />, permission: 'purchase.view', titleKey: 'bills.supplierTitle' },
    { path: '/credits', element: <Credits />, permission: 'credit.view', titleKey: 'credits.title' },
    { path: '/expenses', element: <Expenses />, permission: 'expense.view', titleKey: 'expenses.title' },
  ],
});
